import React, { useEffect, useState } from 'react';
import { ConfiguredToastContainer } from '@hz-design-system/web-ui';
import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import { TEnvConfig } from 'types/TServerContext';
import getFeeds from './repositories/getFeeds';
import { TFeed } from 'types/TFeeds';
import { TCarouselListingItem } from 'types/TCarousels';

let feedsConfig;
let Feeds;
let FeedCarousel;

type TFeedsAppProps = {
  environment: TEnvConfig;
  appState: any;
  asCarousels?: boolean;
  favoriteAdItems?: TCarouselListingItem[];
  onFavClickHandler?: (item: TCarouselListingItem, isFavorite: boolean) => Promise<void>;
  vehicleType: string;
  isLease: boolean;
};

const FeedsApp = ({
  appState,
  environment,
  asCarousels,
  favoriteAdItems,
  onFavClickHandler,
  vehicleType,
  isLease,
}: TFeedsAppProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { l1Category, userPostcode } = appState;

  useEffect(() => {
    const element = document.getElementById('feeds-root');

    if (element) {
      const intersectionObserver = new IntersectionObserver(async (entries) => {
        if (entries[0]?.intersectionRatio > 0) {
          try {
            feedsConfig = await getFeeds(l1Category.id);
            if (feedsConfig.feeds?.length) {
              if (asCarousels) {
                FeedCarousel = (await import(/* webpackChunkName: "feedCarousel" */ './components/Feeds/FeedCarousel'))
                  .default;
              } else {
                Feeds = (await import(/* webpackChunkName: "feeds" */ './components/Feeds/Feeds')).default;
              }
              setIsLoaded(true);
            }
          } catch {
            // Dynamic import failed, component will not be loaded
          }

          intersectionObserver.unobserve(element);
        }
      });

      intersectionObserver.observe(element);
    }
  }, [asCarousels, l1Category]);

  if (!isLoaded) {
    return null;
  }

  return (
    <EnvironmentProvider value={environment}>
      <ConfiguredToastContainer />
      {asCarousels ? (
        <>
          {feedsConfig.feeds.map((feed: TFeed) => (
            <FeedCarousel
              key={feed.feedType}
              l1CategoryId={l1Category.id}
              feed={feed}
              feedPostcode={userPostcode}
              favoriteAdItems={favoriteAdItems}
              onFavClickHandler={onFavClickHandler}
              vehicleType={vehicleType}
              isLease={isLease}
            />
          ))}
        </>
      ) : (
        <Feeds
          feeds={feedsConfig.feeds}
          feedPostcode={userPostcode}
          initialFeed={feedsConfig.initialFeed}
          l1CategoryId={l1Category.id}
        />
      )}
    </EnvironmentProvider>
  );
};

export default FeedsApp;
